"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REDUCER_SET_DEFAULT_CARD = exports.REDUCER_SAVE_NEW_CARD = exports.REDUCER_REMOVE_PAYMENT_CARD = exports.REDUCER_GET_PAYMENT_CARDS = exports.REDUCER_CARD_STATUS = exports.REDUCER_ADD_NEW_CARD = void 0;
const REDUCER_GET_PAYMENT_CARDS = exports.REDUCER_GET_PAYMENT_CARDS = 'getPaymentCards';
const REDUCER_SET_DEFAULT_CARD = exports.REDUCER_SET_DEFAULT_CARD = 'setDefaultCard';
const REDUCER_REMOVE_PAYMENT_CARD = exports.REDUCER_REMOVE_PAYMENT_CARD = 'removePaymentCard';
const REDUCER_ADD_NEW_CARD = exports.REDUCER_ADD_NEW_CARD = 'addNewCard';
const REDUCER_SAVE_NEW_CARD = exports.REDUCER_SAVE_NEW_CARD = 'saveNewCard';
const REDUCER_CARD_STATUS = exports.REDUCER_CARD_STATUS = 'getCardStatus';